import { render, staticRenderFns } from "./SGPFormSemanaComponent.vue?vue&type=template&id=5c945340"
import script from "./SGPFormSemanaComponent.vue?vue&type=script&lang=js"
export * from "./SGPFormSemanaComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports